import HealthWorker from "./List";

export default HealthWorker;
